 import { colors } from "@material-ui/core";
import moment from "moment/moment"
 export const getOrderColorStatues = (state)=>{
  switch(state){
    case 0:
      return colors.amber[500] ;
    case 1:
        return colors.blue[500];
    case 2:
      return colors.green[500];
    case -1:
      return colors.red[500];
    default: 
      return "default";
  }
 }

export const getOrderStatusLabel = (state)=>{
  switch(state){
    case 0:
      return "Pending";
    case 1:
        return "Confirmed";
    case 2:
      return "Invoiced";
    case -1:
      return "Canceled";
    default: 
      return "Pending";
  }
 }

  export const balanceTypes =[
    {id:0, name:'Stocks', label:'الكل', code:0,},
    {id:1, name:'Customers', label:'Shop`s users', code:123},
    {id:2, name:'Customers', label:'Orders', code:261},
  ]
  export const deptTypes =[
    {id:1, name:'Customers', label:'عملاء', code:123},
    {id:2, name:'Customers', label:'موردين', code:261},
  ]
  export const payTypes =[
    {id:0, name:'الكل'},
    {id:1, name:'مسدد'},
    {id:2, name:'غير مسدد'},
  ]

   export const SAdefaultValues = {
        firstTime: true,
        type: balanceTypes[0],
        dateFrom: moment(new Date()).format('YYYY-MM-DD'),
        dateTo: moment(new Date()).format('YYYY-MM-DD'),
        payType: payTypes[0],
        branch:{id:-1, name:'الكل'},
        center:{id:-1, name:'الكل'},
        account: {id: '0', name:''},
        omla:{id:-1, name:'الكل'},
        user:{id:-1, name:'الكل'},
        openBalance:true,
        oldBalance: true,
      
    }